import { render } from "./LeaderboardListItem.vue?vue&type=template&id=6bb65edc&scoped=true&ts=true"
import script from "./LeaderboardListItem.vue?vue&type=script&lang=ts"
export * from "./LeaderboardListItem.vue?vue&type=script&lang=ts"

import "./LeaderboardListItem.vue?vue&type=style&index=0&id=6bb65edc&lang=scss&scoped=true"

import exportComponent from "/workspace/hound-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb65edc"]])

export default __exports__